import * as yup from 'yup';
import axios from 'axios';
import { getPasswordPolicy } from '../../../services/user/changePasswordPolicy';



export const fetchPasswordPolicy = async () => {
  try {
    const response = await axios.get('/api/password-policy');
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar política de senha:", error);
    return {
      requireDigit: true,
      requireLowercase: true,
      requireNonAlphanumeric: true,
      requireUppercase: true,
      requiredLength: 8,
      requiredUniqueChars: 2
    };
  }
};


export const ChangePasswordFormValidation = async () => {
  const policy = await getPasswordPolicy();

  let regexParts = [];
  if (policy.requireLowercase) regexParts.push("(?=.*[a-z])");
  if (policy.requireUppercase) regexParts.push("(?=.*[A-Z])");
  if (policy.requireDigit) regexParts.push("(?=.*\\d)");
  if (policy.requireNonAlphanumeric) regexParts.push("(?=.*[@$!%*?&-])");

  const passwordRegex = new RegExp(`^${regexParts.join('')}.{${policy.requiredLength},}$`);

  return yup.object().shape({
    userId: yup.string().required(),
    newPassword: yup.string()
      .required('Senha é obrigatória')
      .matches(
        passwordRegex,
        `A senha deve conter pelo menos ${policy.requiredLength} caracteres${policy.requireUppercase ? ', uma letra maiúscula' : ''}${policy.requireLowercase ? ', uma minúscula' : ''}${policy.requireDigit ? ', um número' : ''}${policy.requireNonAlphanumeric ? ', um caractere especial' : ''}.`
      ),
      oldPassword: yup.string().required('Senha é obrigatória').matches(
        passwordRegex,
        `A senha deve conter pelo menos ${policy.requiredLength} caracteres${policy.requireUppercase ? ', uma letra maiúscula' : ''}${policy.requireLowercase ? ', uma minúscula' : ''}${policy.requireDigit ? ', um número' : ''}${policy.requireNonAlphanumeric ? ', um caractere especial' : ''}.`
      ),
    confirmPassword: yup.string()
      .required('Confirme a senha')
      .oneOf([yup.ref('newPassword')], 'As senhas devem coincidir')
  });


};



